<template>
  <popup v-model="show"
    class="popup-box"
    height="100%"
    :is-transparent="true">
    <div @click="onClose"
      @touchmove.prevent
      class="mask-wrap">
      <div @click="onClose"
        class="close-box tap">
        <img class="ic-close"
          src="../../../assets/interest/result/ic_close.png">
      </div>
      <div @click.stop=""
        class="container">
        <div class="flex-1">
          <img class="img-share"
            :src="posterImg">
        </div>
        <!-- app中显示的底部 -->
        <div v-if="isApp"
          class="bottom-box">
          <div @click="onShare('wechat')">
            <img class="bottom-img"
              src="../../../assets/interest/result/ic_wechat.png">
            <div>微信</div>
          </div>
          <div @click="onShare('circle')">
            <img class="bottom-img"
              src="../../../assets/interest/result/ic_circle.png">
            <div>朋友圈</div>
          </div>
          <div @click="onSaveAlbum">
            <img class="bottom-img"
              src="../../../assets/interest/result/ic_save_album.png">
            <div>保存图片</div>
          </div>
        </div>
        <!-- 浏览器和微信显示的底部 -->
        <div v-else
          class="share-text">
          长按图片发送给朋友
        </div>
      </div>
    </div>
  </popup>
</template>

<script>
import { actions, injectMixins } from '@/services'
import Popup from 'vux/src/components/popup'
import coreUtil from '@/utils/core'

export default {
  props: {
    shareVisible: Boolean
  },
  components: {
    Popup
  },
  mixins: [injectMixins],
  data () {
    return {
      posterImg: null, // 海报图
      shareInfo: {}, // 分享数据
      isApp: false, // 是否处于app中
      show: false
    }
  },
  created () {
    // 初始化
    this.init()
  },
  watch: {
    show () {
      this.$emit('update:shareVisible', this.show)
    }
  },
  methods: {
    // 初始化
    init () {
      // 是否处于app中
      const isApp = window.location.href.includes('one-sandbox')
      this.isApp = isApp
      if (this.isApp) {
        // 获取分享数据
        this.wxShareData()
      }
      // 获取海报图缓存
      this.posterImg = coreUtil.getLocal(`posterImg-code-${this.code}`)
      if (this.posterImg) {
        this.show = true
      }
    },
    // 获取分享数据
    async wxShareData () {
      const ret = await actions.wxShareData(this.cpCode)
      if (ret.code === 200) {
        this.shareInfo = ret.data
      }
    },
    // 分享
    onShare (type) {
      const bridge = window.__oneLiteBridge.bridge
      bridge.dispatchMsg({
        type: 'open-app-share',
        payload: {
          type,
          showType: 'open',
          mediaType: 'image',
          shareCode: '',
          title: this.shareInfo.title,
          url: this.shareInfo.link,
          thumb: this.posterImg,
          description: this.shareInfo.desc
        }
      })
      actions.accomplishTask(this.code)
    },
    // 保存图片
    onSaveAlbum () {
      const bridge = window.__oneLiteBridge.bridge
      bridge.dispatchMsg({
        type: 'save-album',
        payload: { imgUrl: this.posterImg }
      })
      actions.accomplishTask(this.code)
    },
    // 显示(重新获取海报图缓存,因为父组件会调这个方法)
    onShow () {
      this.posterImg = coreUtil.getLocal(`posterImg-code-${this.code}`)
      this.show = true
    },
    // 关闭
    onClose () {
      this.show = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/core.scss";
@import "@/styles/variable.scss";

.mask-wrap {
  box-sizing: border-box;
  height: 100vh;
  padding: 20px 15px 10px;
  .close-box {
    position: absolute;
    top: 10px;
    right: 20px;
    z-index: 10;
    .ic-close {
      height: 24px;
      width: 24px;
    }
  }
  .container {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    .img-share {
      max-width: 100%;
      max-height: 100%;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
    }
    .bottom-box {
      color: $white;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding: 20px 40px 0;
      text-align: center;
      .bottom-img {
        height: 48px;
        width: 48px;
        &:active {
          opacity: 0.5;
        }
      }
    }
    .share-text {
      color: $white;
      font-size: 14px;
      padding: 10px 0;
      text-align: center;
    }
  }
}
</style>
